<template>
    <div 
    :class="{'colored-indicator': isColored, 'not-colored-indicator': !isColored}"
    class="indicator-item"
    >
    
    </div>
</template>

<script>
export default {
    name: 'IndicatorItem',
    props:{
        indicatorNumber: Number,
        stepNumber: Number
    },
    computed: {
        isColored(){
            if (this.indicatorNumber <= this.stepNumber) {
                return true
            }
            else {
                return false
            }
        }
    }
}
</script>

<style>
    
</style>
